import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=349c4710&scoped=true"
import script from "./Badge.vue?vue&type=script&setup=true&lang=js"
export * from "./Badge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Badge.vue?vue&type=style&index=0&id=349c4710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c4710",
  null
  
)

export default component.exports